module.exports = __webpack_public_path__ + "static/media/4d-result-icon.7f3ea805.svg";